export default __webpack_public_path__ + "static/omoArsenalBlue-98c317cfd8225ab890e8c246b74879cc.svg";